import React, { useState } from 'react';
import { FaFileUpload, FaSpinner } from 'react-icons/fa';
import './PayslipForm.scss';

const PayslipForm = ({ employee, onSubmit, onCancel, uploading }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); // 0-11
  
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [pdfFile, setPdfFile] = useState(null);
  const [errors, setErrors] = useState({});
  
  const months = [
    { value: 0, label: 'JAN' },
    { value: 1, label: 'FEB' },
    { value: 2, label: 'MAR' },
    { value: 3, label: 'APR' },
    { value: 4, label: 'MAY' },
    { value: 5, label: 'JUN' },
    { value: 6, label: 'JUL' },
    { value: 7, label: 'AUG' },
    { value: 8, label: 'SEP' },
    { value: 9, label: 'OCT' },
    { value: 10, label: 'NOV' },
    { value: 11, label: 'DEC' }
  ];
  
  const years = [currentYear - 2, currentYear - 1, currentYear, currentYear + 1];
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    if (file.type !== 'application/pdf') {
      setErrors({ ...errors, file: 'Only PDF files are allowed' });
      setPdfFile(null);
      return;
    }
    
    if (file.size > 5 * 1024 * 1024) { // 5MB size limit
      setErrors({ ...errors, file: 'File size cannot exceed 5MB' });
      setPdfFile(null);
      return;
    }
    
    setErrors({ ...errors, file: null });
    setPdfFile(file);
  };
  
  const handleYearChange = (e) => {
    setSelectedYear(parseInt(e.target.value));
    setErrors({ ...errors, year: null, month: null });
  };
  
  const handleMonthChange = (e) => {
    setSelectedMonth(parseInt(e.target.value));
    setErrors({ ...errors, month: null, year: null });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newErrors = {};
    
    if (!selectedYear) {
      newErrors.year = 'Please select a year';
    }
    
    if (selectedMonth === undefined || selectedMonth === null) {
      newErrors.month = 'Please select a month';
    }
    
    if (!pdfFile) {
      newErrors.file = 'Please upload a PDF file';
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    // Format as "YYYY-MMM" for consistency with existing code
    const payMonth = `${selectedYear}-${months[selectedMonth].label}`;
    onSubmit(payMonth, pdfFile);
  };
  
  return (
    <div className="payslip-form">
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="payYear">Year*</label>
            <select
              id="payYear"
              className={errors.year ? 'error' : ''}
              value={selectedYear}
              onChange={handleYearChange}
              disabled={uploading}
            >
              <option value="">Select Year</option>
              {years.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            {errors.year && <div className="error-message">{errors.year}</div>}
          </div>
          
          <div className="form-group">
            <label htmlFor="payMonth">Month*</label>
            <select
              id="payMonth"
              className={errors.month ? 'error' : ''}
              value={selectedMonth}
              onChange={handleMonthChange}
              disabled={uploading}
            >
              <option value="">Select Month</option>
              {months.map(month => (
                <option key={month.value} value={month.value}>
                  {month.label}
                </option>
              ))}
            </select>
            {errors.month && <div className="error-message">{errors.month}</div>}
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>Payslip PDF*</label>
            <div className="file-input-wrapper">
              <div className="file-name">
                {pdfFile ? pdfFile.name : 'No file selected'}
              </div>
              <label className="file-input-label">
                Browse Files
                <input
                  type="file"
                  accept=".pdf"
                  onChange={handleFileChange}
                  disabled={uploading}
                />
              </label>
            </div>
            {errors.file && <div className="error-message">{errors.file}</div>}
          </div>
        </div>
        
        {uploading && (
          <div className="upload-progress">
            <FaSpinner className="spinner" />
            <span>Uploading payslip...</span>
          </div>
        )}
        
        <div className="form-actions">
          <button 
            type="button" 
            className="cancel-button" 
            onClick={onCancel}
            disabled={uploading}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="submit-button"
            disabled={uploading}
          >
            {uploading ? (
              <>
                <FaSpinner className="spinner" />
                <span>Uploading...</span>
              </>
            ) : (
              <>
                <FaFileUpload className="icon" />
                <span>Upload Payslip</span>
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PayslipForm; 